import "./_SocialProof.scss";
import enquire from 'enquire.js';
import { Media } from "@Utilities/Media";

export class SocialProof
{
	private activeProof: HTMLDivElement = null;
	private containerDesktop: HTMLElement;
	private containerMobile: HTMLElement;
	private containerProof: HTMLElement;
	private newActiveProof: HTMLDivElement = null;
	private proofs: NodeListOf<HTMLDivElement>;
	private proofIndex = 0;
	private socialProof: HTMLDivElement = null;
	private zoomIcon: HTMLSpanElement = null;

	constructor()
	{
		this.ConfigureLayout();
		this.ConfigureSocialProofs();
	}

	private ConfigureLayout = (): void =>
	{
		this.containerDesktop = document.querySelector(".proofDesktop");
		this.containerMobile = document.querySelector(".proofMobile");
		this.containerProof = document.querySelector("#socialProof");

		if (this.containerDesktop != null && this.containerMobile != null && this.containerProof != null)
		{
			enquire.register(Media.MediaDesktop, {
				deferSetup: true,
				match: () =>
				{
					this.LayoutDesktop();
				},
				unmatch: () =>
				{
					this.LayoutMobile();
				}
			});
		}
	};

	private ConfigureSocialProofs = (): void =>
	{
		this.zoomIcon = document.querySelector(".prdImg__zoom");
		this.socialProof = document.querySelector(".socialProof");
		this.proofs = document.querySelectorAll(".socialProof .proof");

		if (this.socialProof != null && this.proofs.length > 0)
		{
			this.socialProof.classList.add("active");

			this.proofs.forEach(proof =>
			{
				proof.addEventListener('animationend', e =>
				{
					if (proof === this.activeProof)
					{
						this.activeProof.classList.remove("active", "proofIn", "proofOut");
					}
				});
			});

			if (this.zoomIcon != null)
			{
				this.zoomIcon.style.display = "none";
			}

			const first = this.proofs[0];
			first.classList.add("proofIn", "active");

			setTimeout(this.ShowNextProof, 5500);
		}
	};

	private LayoutDesktop = (): void =>
	{
		if (this.containerDesktop !== null && this.containerProof !== null)
		{
			this.containerDesktop.appendChild(this.containerProof);
		}
	};

	private LayoutMobile = (): void =>
	{
		if (this.containerMobile !== null && this.containerProof !== null)
		{
			this.containerMobile.appendChild(this.containerProof);
		}
	};

	private ShowNextProof = (): void =>
	{
		this.activeProof = document.querySelector(".proof.active");
		this.activeProof.classList.add("proofOut");
		this.proofIndex++;

		if (this.proofIndex < this.proofs.length)
		{
			this.newActiveProof = this.proofs[this.proofIndex];
			this.newActiveProof.classList.add("proofIn", "active");
			setTimeout(this.ShowNextProof, 5500);
		}
		else
		{
			if (this.socialProof != null)
			{
				setTimeout(() =>
				{
					this.socialProof.classList.remove("active");
				}, 5500);
			}

			if (this.zoomIcon != null)
			{
				this.zoomIcon.style.display = null;
			}
		}
	}
}